// This component displays a 1-10 scale for the NPS with the percentage breakdown for each number response category
import React, { Component } from "react"
import PropTypes from "prop-types"
import NpsScaleSegment from "./NpsScaleSegment"
import ScoreShape from "../../../state/shapes/ScoreShape"

class NetPerformerScale extends Component {
  getColor = type => {
    switch (type) {
      case 0:
        return this.props.detractorColor
      case 1:
        return this.props.passiveColor
      default:
        return this.props.promoterColor
    }
  }

  render() {
    return (
      <table
        className="hidden-xs-down"
        cellPadding="0"
        cellSpacing="0"
        style={{ width: "100%", borderCollapse: "collapse" }}
      >
        <tbody>
          <tr>
            {this.props.data.map(score => {
              return (
                <td key={score.scoreValue} style={{ width: "10%" }}>
                  <NpsScaleSegment
                    scaleNumber={score.scoreValue}
                    peoplePercentage={Math.round(score.percentage).toFixed(1)}
                    hexColor={this.getColor(score.scoreType)}
                    key={score.scoreValue}
                  />
                </td>
              )
            }, this)}
          </tr>
        </tbody>
      </table>
    )
  }
}

NetPerformerScale.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(ScoreShape)).isRequired,
  detractorColor: PropTypes.string.isRequired,
  passiveColor: PropTypes.string.isRequired,
  promoterColor: PropTypes.string.isRequired
}

export default NetPerformerScale



// WEBPACK FOOTER //
// ./src/components/widgets/CustomNPS/NetPerformerScale.jsx